import { getTowns } from './getTowns'

export default {
  getTowns
}
